import { mapActions, mapGetters, mapMutations } from 'vuex'
import VueJsonPretty from 'vue-json-pretty'
import ConfirmSave from '@/components/modals/confirm-save/index.vue'

export default {
  props: {
    readonly: {
      required: false,
      type: Boolean,
      default: false
    },
    variable: {
      required: true,
      type: String,
      default: ''
    }
  },
  components: {
    VueJsonPretty,
    ConfirmSave

  },
  data () {
    return {
      isLoading: false,
      dialog: false,
      selectedType: '',
      costMetrics: [
        { name: 'Alto', value: 'alto' },
        { name: 'Baixo', value: 'baixo' },
        { name: 'Local', value: 'local' }
      ],
      costMetricsApi: [],
      planTypes: [],
      tax: 0,
      cedroMargin: 0,
      commission: 0,
      total: 0,
      calculationBasis: 0,
      minimumPrice: 0,
      cost: 0,
      managerConfirmSave: false,
      selectedMetric: null
    }
  },
  computed: {
    ...mapGetters([
      'getterSelectedSystemProvider',
      'getterPlanType',
      'getterSystemProviderMetrics'
    ]),
    idSelectedProvider () {
      return this.getterSelectedSystemProvider.idSystemProvider
    },
    idPlanTypes () {
      return this.getterPlanType
    },
    isDisabled () {
      return this.selectedType === ''
    }
  },
  // watch: {
  //   managerEditCostVariable (value) {
  //     if (!value) {
  //       this.managerConfirmDeleteInvoice = true
  //     }
  //   }
  // },
  mounted () {
    this.dialog = true
    this.getSystemProviderMetrics()
    this.getPlanTypes()
  },
  beforeDestroy () {
    this.SET_SELECTED_SYSTEM_PROVIDER()
  },
  methods: {
    ...mapActions([
      'actionEditSystemProvider',
      'actionRemoveFieldAvailable',
      'actionAddFieldAvailable',
      'actionAddParamsFields',
      'actionEditParamsFields',
      'actionAddRequestFields',
      'actionRemoveRequestFields',
      'actionEditRequestFields',
      'actionGetAllSystemProviders',
      'actionGetSystemProviderClassifications',
      'actionGetSystemProviderSalesValues',
      'actionGetSystemProviderMetrics',
      'actionGetPlanTypes',
      'actionEditSystemProviderMetrics'

    ]),
    ...mapMutations([
      'SET_SELECTED_SYSTEM_PROVIDER'
    ]),
    getSystemProviderMetrics () {
      this.actionGetSystemProviderMetrics()
      this.costMetricsApi = this.getterSystemProviderMetrics
    },
    getPlanTypes () {
      this.actionGetPlanTypes()
      this.planTypes = this.getterPlanType
    },
    closeModal () {
      this.isLoading = this.dialog = false
      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    editProvider () {
      if (!this.isDisabled) {
        const systemProvider = {
          ...this.getterSelectedSystemProvider,
          type: this.selectedType,
          minimumPrice: !this.minimumPrice ? 0 : parseFloat(this.minimumPrice.toString().replace('.', '').replace(',', '.')),
          cost: !this.cost ? 0 : parseFloat(this.cost.toString().replace('.', '').replace(',', '.')),
          sourceName: this.selectedProviderSources || '',
          description: this.description,
          mock: this.mock,
          idSystemProviderClassification: this.selectedProviderClassification
        }

        this.isLoading = true

        this.actionEditSystemProvider(systemProvider)
          .then(() => {
            this.closeModal()

            this.actionGetAllSystemProviders()

            this.sendToast({
              text: 'Provider atualizado com sucesso!',
              type: 'success'
            })
          })
          .catch(() => {
            this.sendToast({
              text: 'Ocorreu um erro ao atualizar o provider, tente novamente mais tarde!',
              type: 'danger'
            })

            this.isLoading = false
          })
      } else {
        this.sendToast({
          text: 'Os campos não foram preenchidos corretamente!',
          type: 'warning'
        })
      }
    },
    editCostVariable () {
      this.managerConfirmSave = true
    },
    setMetric (e) {
      const selectedPlan = this.planTypes.find(plan => plan.name.toLowerCase() === this.variable.toLowerCase())

      const metrics = this.costMetricsApi.filter(metric => metric.idPlanType === selectedPlan.idPlanType)

      this.selectedMetric = metrics.find(metric => metric.name && metric.name.toLowerCase() === e.toLowerCase())

      if (this.selectedMetric) {
        this.tax = this.selectedMetric.tax
        this.cedroMargin = this.selectedMetric.margin
        this.commission = this.selectedMetric.commission

        this.total = this.tax + this.cedroMargin + this.commission
        this.total = this.total.toFixed(4)

        this.calculationBasis = 1 - this.total
        this.calculationBasis = this.calculationBasis.toFixed(4)
      } else {
        this.sendToast({
          text: 'Não foi possível encontrar a métrica selecionada!',
          type: 'warning'
        })
      }
    },
    confirmResponse () {
      this.actionEditSystemProviderMetrics({
        idSystemProviderMetrics: this.selectedMetric.idSystemProviderMetrics,
        idPlanType: this.idPlanTypes,
        tax: this.tax,
        margin: this.cedroMargin,
        commission: this.commission,
        calculationBasis: this.calculationBasis
      }).then(() => {
        this.sendToast({
          text: 'Métrica atualizada com sucesso!',
          type: 'success'
        })
        this.managerConfirmSave = false
        this.dialog = false
        this.getSystemProviderMetrics()
      }).catch(() => {
        this.sendToast({
          text: 'Ocorreu um erro ao atualizar a métrica, tente novamente mais tarde!',
          type: 'danger'
        })
      })
    }
  }
}
